<template>
  <div id="main" :class="isMobile ? 'mobile_wrap' : ''">
    <template v-if="isMobile">
      <header class="header_wrap">
        <img src="../assets/common/guro_logo.png" alt="SMART GURO"/>
        <img src="../assets/common/logo_orange.svg" alt="구로구 중장년 일드림 센터" @click="movePage('/Dashboard')"/>
        <div class="btn_menu" @click="toggleMenu">
          메뉴 버튼
          <div v-if="isShowMenu">
            <div @click="movePage('/Intro')">일드림센터 소개</div>
            <div @click="movePage('/Program/List')">프로그램 정보</div>
            <div @click="movePage('/Job/List')">취업 정보</div>
            <div @click="movePage('/Notice/List')">커뮤니티</div>
            <div @click="movePage('/Participation/Club')">참여마당</div>
          </div>
        </div>
      </header>
      <div class="header_banner">
        <div class="mask"></div>
        <div class="header_banner_cont">
          <div>
            <div>구로구 산업특화 중장년 역량강화 교육 및 일자리 허브</div>
            <img src="../assets/header/header_logo.svg" alt="중장년 일드림 센터"/>
            <div @click.stop="movePage('/Intro')">센터 소개 및 사업 안내 >></div>
          </div>
        </div>
      </div>
    </template>
    <header class="header_wrap" v-else>
      <div class="header_top">
        <div>
          <a href="https://www.guro.go.kr/" target="_blank">구로구청 홈페이지</a>
        </div>
      </div>
      <div class="header_middle">
        <div>
          <div class="header_logo">
            <img src="../assets/common/guro_logo.png" alt="SMART GURO"/>
            <img src="../assets/common/logo_black.svg" alt="구로구 중장년 일드림 센터" @click="movePage('/Dashboard')"/>
          </div>
          <div class="header_menu">
            <div @click="movePage('/Intro')">
              일드림센터 소개
              <div class="hover_box">
                <div @click.stop="movePage('/Intro')">인사말</div>
                <div @click.stop="movePage('/Facility')">시설현황</div>
                <div @click.stop="movePage('/Location')">오시는 길</div>
              </div>
            </div>
            <div @click="movePage('/Program/List')">프로그램 정보</div>
            <div @click="movePage('/Job/List')">취업 정보</div>
            <div @click="movePage('/Notice/List')">
              커뮤니티
              <div class="hover_box">
                <div @click.stop="movePage('/Notice/List')">공지·뉴스</div>
                <div @click.stop="movePage('/BoardData/List')">자료실</div>
                <div @click.stop="movePage('/FAQ')">자주 묻는 질문</div>
              </div>
            </div>
            <div @click="movePage('/Participation/Club')">
              참여마당
              <div class="hover_box">
                <div @click.stop="movePage('/Participation/Club')">동아리방</div>
                <div @click.stop="movePage('/Participation/Nest')">꿈둥지</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header_banner">
        <div class="mask"></div>
        <div class="header_banner_cont">
          <div>
            <div>구로구 산업특화 중장년 역량강화 교육 및 일자리 허브</div>
            <img src="../assets/header/header_logo.svg" alt="중장년 일드림 센터"/>
            <div @click.stop="movePage('/Intro')">센터 소개 및 사업 안내 >></div>
          </div>
        </div>
      </div>
    </header>
    <div class="top_menu_wrap" v-if="!isDashboard">
      <div class="top_menu_cont">
        <img src="../assets/header/ic_home.svg" alt=""/>
        <select v-model="selectMenu1" @change="changeMenu1">
          <option value="/Intro">일드림센터 소개</option>
          <option value="/Program/List">프로그램 정보</option>
          <option value="/Job/List">취업 정보</option>
          <option value="/Notice/List">커뮤니티</option>
          <option value="/Participation/Club">참여마당</option>
        </select>
        <select v-model="selectMenu2" @change="changeMenu2" v-if="selectMenu1.includes('Intro') || selectMenu1.includes('Facility') || selectMenu1.includes('Location')">
          <option value="/Intro">인사말</option>
          <option value="/Facility">시설현황</option>
          <option value="/Location">오시는 길</option>
        </select>
        <select v-model="selectMenu2" v-else-if="selectMenu1.includes('Program')">
          <option value="">프로그램 정보 목록</option>
        </select>
        <select v-model="selectMenu2" v-else-if="selectMenu1.includes('Job')">
          <option value="">취업 정보 목록</option>
        </select>
        <select v-model="selectMenu2" @change="changeMenu2" v-else-if="selectMenu1.includes('Notice') || selectMenu1.includes('BoardData') || selectMenu1.includes('FAQ')">
          <option value="/Notice/List">공지·뉴스</option>
          <option value="/BoardData/List">자료실</option>
          <option value="/FAQ">자주 묻는 질문</option>
        </select>
        <select v-model="selectMenu2" @change="changeMenu2" v-else-if="selectMenu1.includes('Participation')">
          <option value="/Participation/Club">동아리방(Community)</option>
          <option value="/Participation/Nest">꿈둥지(구직자전용카페)</option>
        </select>
      </div>
    </div>
    <router-view/>
    <footer class="footer_wrap" v-if="isMobile">
      <div class="footer_cont">
        <div class="footer_cont_top">
          <div>
            <img src="../assets/common/guro_logo.png" alt="SMART GURO"/>
            <img src="../assets/common/logo_white.svg" alt="구로구 중장년 일드림 센터"/>
          </div>
          <div>
            <div class="footer_menu">
              <div>소개</div>
              <div class="link" @click="movePage('/Intro')">일드림센터 소개</div>
              <div class="link" @click="movePage('/Program/List')">프로그램 소개</div>
            </div>
            <div class="footer_menu">
              <div>서비스</div>
              <div class="link" @click="movePage('/Notice/List')">공지·뉴스</div>
              <div class="link" @click="movePage('/FAQ')">자주 묻는 질문</div>
            </div>
          </div>
          <div>
            <div class="footer_menu">
              <div>주소</div>
              <div>[08284] 서울특별시 개봉로23길 10 (개봉소공인드림창작소 402호)</div>
              <div>TEL : 02-6737-7448~50, FAX : 02-6737-7447</div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="footer_cont_bottom">
          <div>Copyright 2023 INGEUS. All Rights Reserved</div>
          <div class="footer_icon">
            <div><img src="../assets/mobile/m_ic_fb.png" alt="구로구 중장년 일드림 센터 페이스북 링크"/></div>
            <div><img src="../assets/mobile/m_ic_twitter.png" alt="구로구 중장년 일드림 센터 트위터 링크"/></div>
            <div><img src="../assets/mobile/m_ic_linkedin.png" alt="구로구 중장년 일드림 센터 링크드인 링크"/></div>
          </div>
        </div>
      </div>
    </footer>
    <footer class="footer_wrap" v-else>
      <div class="footer_cont">
        <div class="footer_cont_top">
          <img src="../assets/common/guro_logo.png" alt="SMART GURO"/>
          <img src="../assets/common/logo_white.svg" alt="구로구 중장년 일드림 센터"/>
          <div>
            <div class="footer_menu">
              <div>소개</div>
              <div class="link" @click="movePage('/Intro')">일드림센터 소개</div>
              <div class="link" @click="movePage('/Program/List')">프로그램 소개</div>
            </div>
            <div class="footer_menu">
              <div>서비스</div>
              <div class="link" @click="movePage('/Notice/List')">공지·뉴스</div>
              <div class="link" @click="movePage('/FAQ')">자주 묻는 질문</div>
            </div>
            <div class="footer_menu">
              <div>주소</div>
              <div>[08284] 서울특별시 개봉로23길 10 (개봉소공인드림창작소 402호)</div>
              <div>TEL : 02-6737-7448~50, FAX : 02-6737-7447</div>
              <div class="footer_icon">
                <div><img src="../assets/footer/ic_fb.svg" alt="구로구 중장년 일드림 센터 페이스북 링크"/></div>
                <div><img src="../assets/footer/ic_twitter.svg" alt="구로구 중장년 일드림 센터 트위터 링크"/></div>
                <div><img src="../assets/footer/ic_linkedin.svg" alt="구로구 중장년 일드림 센터 링크드인 링크"/></div>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="footer_cont_bottom">
          <div>Copyright 2023 INGEUS. All Rights Reserved</div>
          <div></div>
          <div></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import common from '../script/common'

export default {
  data () {
    return {
      isMobile: common.detectMobile(),
      isDashboard: true,
      selectMenu1: '',
      selectMenu2: '',
      isShowMenu: false
    }
  },
  mounted () {
    this.isDashboard = window.location.href.includes('Dashboard')
  },
  updated () {
    this.isDashboard = window.location.href.includes('Dashboard')
    console.log(window.location.href)
    if (window.location.href.includes('Intro') || window.location.href.includes('Facility') || window.location.href.includes('Location')) {
      this.selectMenu1 = '/Intro'
      this.selectMenu2 = window.location.href.includes('Intro') ? '/Intro' : window.location.href.includes('Facility') ? '/Facility' : window.location.href.includes('Location') ? '/Location' : ''
    } else if (window.location.href.includes('Notice') || window.location.href.includes('BoardData') || window.location.href.includes('FAQ')) {
      this.selectMenu1 = '/Notice/List'
      this.selectMenu2 = window.location.href.includes('Notice') ? '/Notice/List' : window.location.href.includes('BoardData') ? '/BoardData/List' : window.location.href.includes('FAQ') ? '/FAQ' : ''
    } else if (window.location.href.includes('Participation')) {
      this.selectMenu1 = '/Participation/Club'
      this.selectMenu2 = window.location.href.includes('Club') ? '/Participation/Club' : window.location.href.includes('Nest') ? '/Participation/Nest' : ''
    } else {
      this.selectMenu2 = ''
      if (window.location.href.includes('Program')) {
        this.selectMenu1 = '/Program/List'
      } else if (window.location.href.includes('Job')) {
        this.selectMenu1 = '/Job/List'
      }
    }
  },
  methods: {
    movePage (path) {
      this.$router.push(path)
    },
    changeMenu1 () {
      this.movePage(this.selectMenu1)
    },
    changeMenu2 () {
      this.movePage(this.selectMenu2)
    },
    toggleMenu () {
      this.isShowMenu = !this.isShowMenu
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue